export { default } from './track-clicks';
export {
  filterOutLocaleFromUrlArray,
  trackUserClick,
} from './track-clicks.utils';
